import { Component, h, Host } from '@stencil/core';

@Component({
  tag: 'pn-product-tile',
  styleUrl: 'pn-product-tile.scss',
})
export class PnProductTile {
  render() {
    return (
      <Host>
        <slot name="illustration" />
        <div class="tilecontent">
          <div class="details">
            <slot name="content" />
            <div class="info">
              <slot />
            </div>
            <slot name="note" />
          </div>
          <slot name="price" />
        </div>
      </Host>
    );
  }
}
